export const locale = {
  lang: 'en',
  data: {
    ERROR: {
      TITLE: 'Error Page!',
      HTTP: {
        403: 'You are not authorized to access this page.',
        404: 'The page does not exist.',
      },
    },
  },
};
